import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from './connector';
import i18n from '../../lang/i18n'
import axios from "axios";
import { Plugins } from '@capacitor/core';
import { connectPagination } from 'react-instantsearch-dom';

const places = typeof window !== 'undefined' && require('places.js');
const { Geolocation } = Plugins;
const { Device } = Plugins;
const debug = process.env.GATSBY_DEBUG;
const isBrowser = typeof window !== "undefined"
var tracker = null;
var userCoords = null;
var firstTime = true;


class Places extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  static propTypes = {
    refine: PropTypes.func.isRequired,
    defaultRefinement: PropTypes.object.isRequired,
  };

  createRef = c => (this.element = c);

  handleClick(){
    if (document.getElementById("paginatonButton0")) {
      document.getElementById("paginatonButton0").click();
    }
  }

  componentDidMount() {
/*     if (isBrowser) {
      const info = Device.getInfo();
      info.then(function(v){
          console.log(v);
          if (v.platform === "ios" || v.platform === "android" || v.platform === "web") {
            const coordinates = Geolocation.getCurrentPosition();
            coordinates.then(function(x){
              console.log('Current location', x);
            });
          }
      });
    } */
    
    if (isBrowser) {
      const { refine, defaultRefinement } = this.props;

      const autocomplete = places({
        container: this.element,
        language: i18n.language || 'de',
        aroundLatLngViaIP: true,
        //style: false,
        debug: true,
      });

      autocomplete.on('change', event => {
        if (debug) console.log(event.suggestion.latlng);
        refine(event.suggestion.latlng);

      });

      autocomplete.on('locate', event => {
        if (firstTime) {
          //tracker = navigator.geolocation.getCurrentPosition(function (_ref3) {
          //var coords = _ref3.coords;
          const info = Device.getInfo();
          info.then(function(v){
              //console.log(v);
              if (v.platform === "ios" || v.platform === "android" || v.platform === "web") {
                const coordinates = Geolocation.getCurrentPosition();
                coordinates.then(function(x){
                  console.log('Current location', x.coords);

                  var accuracy = x.coords.accuracy
                  var refinedCoords = { lat: x.coords.latitude, lng: x.coords.longitude }

                  console.log("Accuracy in meters: ", accuracy);

                  axios({
                    url: "https://nominatim.openstreetmap.org/reverse?format=json&lat=" + x.coords.latitude + "&lon=" + x.coords.longitude + "&addressdetails=1&accept-language=" + i18n.language || 'de',
                    method: 'get',
                    headers: {
                        'Accept': 'application/json'
                    }
                    }).then((response) => {
                      if (response.data.address) {
                        var street = response.data.address.road || "";
                        var number = response.data.address.house_number || "";
                        var zipcode = response.data.address.postcode || "";
                        var cityOrTown = response.data.address.city || response.data.address.town || "";
                        var city = cityOrTown || "";
                        var country = response.data.address.country || "";
                        var address = street + " " + number + ", " + zipcode + " " + city + ", " + country;
                        console.log(address);
                        autocomplete.setVal(address);
                        autocomplete.close();
                      }
                    }).catch(function (error) {
                      console.log(error);
                      autocomplete.setVal(i18n.t('my_position', "Mein Standort"));
                      autocomplete.close();
                    });

                  refine(refinedCoords);
                  firstTime = false;
                });
              }
            });
        } 
      });


      autocomplete.on('reverse', event => {
        if (debug) console.log('revers: ', event);
      });


      autocomplete.on('clear', () => {
        if (debug) console.log(defaultRefinement);
        firstTime = true;
        refine(defaultRefinement);
        refine(0);
        //refine();
      });
    }
  }
 
  render() {
    return (
      <div>
        <input
          ref={this.createRef}
          onChange={this.handleClick}
          type="search"
          id="address"
          autoFocus={false}
          placeholder={i18n.t('search_searchbar_placeholder2', "WO")}
          />
          <CustomPagination/>
      </div>
      
    );
  }
}

const Pagination = ({ currentRefinement, nbPages, refine, createURL }) => (
  <ul className="hidden-alt">
    {new Array(nbPages).fill(null).map((_, index) => {
      const page = index + 1;
      const style = {
        fontWeight: currentRefinement === page ? 'bold' : '',
      };
      // console.log(createURL(page))
      return (
        <li key={index} className="ais-Pagination-item">
          <a
            id={"paginatonButton" + index}
            className="ais-Pagination-link"
            href={createURL(page)}
            style={style}
            onClick={event => {
              event.preventDefault();
              refine(page);
            }}
          >
            {page}
          </a>
        </li>
      );
    })}
  </ul>
);

const CustomPagination = connectPagination(Pagination);

export default connect(Places);


